import React, { useEffect, useState } from "react";
import Slider from "react-slick";

import StepContent from "../SimpleSteps/StepContent";
import { SIMPLE_STEPS_DATA } from "../../constants/simpleStepsData";
import { sliderSetting } from "../../constants/sliderSetting";

function SimpleSteps() {
  const [activeStep, setActiveStep] = useState("1");
  const handleStepClick = (item) => {
    setActiveStep(item);
  };

  useEffect(() => {
    const stepListContent = document.querySelector(".step-list-content");
    stepListContent.classList.add("active");

    const intervalId = setInterval(() => {
      const currentIndex = SIMPLE_STEPS_DATA.findIndex(
        (item) => item.StepNumber === activeStep
      );

      const nextIndex = (currentIndex + 1) % SIMPLE_STEPS_DATA.length;

      setActiveStep(SIMPLE_STEPS_DATA[nextIndex].StepNumber);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [activeStep]);

  return (
    <>
      <section>
        <div className="step-main">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="secondry-heading">
                  Activate FlexiCash in 3 simple steps
                </h2>
                <div className="steps-inner-box">
                  <div className="step-list">
                    <Slider {...sliderSetting.horizontalSlider}>
                      {SIMPLE_STEPS_DATA.map((item) => (
                        <StepContent
                          key={item.id}
                          StepNumber={item.StepNumber}
                          StepHeading={item.StepHeading}
                          StepDesc={item.StepDesc}
                          isActive={activeStep === item.id}
                          onClick={() => handleStepClick(item.StepNumber)}
                        />
                      ))}
                    </Slider>
                  </div>

                  <div
                    className={`step-list-content text-lg-end ${
                      activeStep ? "active" : ""
                    }`}
                  >
                    {SIMPLE_STEPS_DATA.map(
                      (item) =>
                        activeStep === item.StepNumber && (
                          <img
                            key={item.id}
                            src={item.StepImageSrc}
                            alt={item.ImageAltText}
                            className="img-fluid"
                          />
                        )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SimpleSteps;
